module.exports = __webpack_public_path__ + "img/interface-screen-10.ea891ac.jpg";